<template>
  <small class="inline-block text-sm text-gray-600" data-testid="clr-helper-text">
    <slot />
  </small>
</template>
